<div class="flex flex-col h-full bg-slate-900 text-white overflow-hidden shadow-2xl">
    <!-- Header: Logo + Toggle -->
    <div class="h-[72px] flex items-center border-white/5 transition-all duration-300 overflow-hidden px-0">

        <!-- Toggle Container (Mirrors Nav Icon Container for Alignment) -->
        <div class="flex items-center justify-center shrink-0 transition-all duration-300"
            [style.width]="layoutService.isSidebarCollapsed() ? '72px' : '64px'">
            <fk-button variant="ghost"
                [svgIcon]="layoutService.isSidebarCollapsed() ? iconConstants.MENU : iconConstants.CHEVRON_LEFT"
                (click)="layoutService.toggleSidebar()" [iconSize]="'text-[28px]'"
                extraClass="!text-slate-400 hover:!text-white hover:!bg-transparent !border-transparent hover:!border-white/10 !rounded-md !h-10 !w-10 !p-0 shrink-0 border">
            </fk-button>
        </div>

        <div class="transition-all duration-300 overflow-hidden whitespace-nowrap select-none"
            [class.w-0]="layoutService.isSidebarCollapsed()" [class.opacity-0]="layoutService.isSidebarCollapsed()"
            [class.invisible]="layoutService.isSidebarCollapsed()" [class.ml-0]="layoutService.isSidebarCollapsed()">
            <img src="assets/images/logo.svg" alt="FreightKey" class="h-8 object-contain" />
        </div>
    </div>

    <!-- Organization Capsule at Top (Hidden when Collapsed) -->
    @if (authService.user(); as user) {
        @if (!layoutService.isSidebarCollapsed() && user.role !== 'PLATFORM_SUPER_ADMIN' && user.organizationName) {
        <div class="px-md pb-2 transition-all duration-300 shrink-0">
            <div class="w-full bg-[#1e293b]/70 border border-white/5 rounded-lg py-2 px-md text-center text-[13px] font-medium text-slate-200 select-none truncate">
                {{ user.organizationName }}
            </div>
        </div>
        }
    }

    <!-- Scrollable Menu Items -->
    <div class="flex-1 overflow-y-auto py-4 space-y-1 custom-scrollbar overflow-x-hidden">
        @for (item of menuItems(); track item.label) {
        <a [routerLink]="item.route" (click)="!item.route && onLogout()"
            [class.!text-primary]="isRouteActive(item)"
            [class.!border-primary]="isRouteActive(item)"
            class="cursor-pointer flex items-center h-16 transition-all duration-200 text-white/90 hover:text-primary group relative border-l-[3px] border-transparent overflow-hidden mx-0"
            [matTooltip]="layoutService.isSidebarCollapsed() ? item.label : ''" matTooltipPosition="right">

            <div class="flex items-center justify-center shrink-0 transition-all duration-300"
                [style.width]="layoutService.isSidebarCollapsed() ? '66px' : '60px'">
                <mat-icon
                    class="!w-[60px] !h-[60px] text-[60px] transition-transform duration-300 group-hover:scale-110"
                    [svgIcon]="item.icon"></mat-icon>
            </div>

            <span class="transition-all duration-300 overflow-hidden whitespace-nowrap text-[15px] tracking-wide"
                [class.w-0]="layoutService.isSidebarCollapsed()" [class.opacity-0]="layoutService.isSidebarCollapsed()"
                [class.invisible]="layoutService.isSidebarCollapsed()">
                {{ item.label }}
            </span>
        </a>
        }
    </div>

    <!-- Bottom: Version + Profile Row -->
    @if (authService.user(); as user) {
    <div class="mt-auto border-t border-white/5 transition-all duration-300 w-full flex flex-col items-center pb-3 pt-2 gap-2">

        <!-- Version pill -->
        @if (!layoutService.isSidebarCollapsed()) {
        <div class="w-[calc(100%-24px)] bg-[#1e293b]/60 border border-white/5 rounded-lg py-1.5 text-center text-[12px] font-medium text-slate-400 select-none tracking-wide">
            Versions: V{{ appVersion }}
        </div>
        }

        <!-- Profile row -->
        <div class="w-full flex items-center px-3 gap-3 min-h-[52px]"
            [class.justify-center]="layoutService.isSidebarCollapsed()">

            <!-- Avatar -->
            <div class="w-10 h-10 shrink-0 rounded-full bg-gradient-to-br from-primary to-primary-hover flex items-center justify-center font-bold text-white shadow-lg border-2 border-white/10 select-none text-sm"
                [matTooltip]="layoutService.isSidebarCollapsed() ? (user.name + '\n' + getRoleLabel(user.role)) : ''"
                matTooltipPosition="right">
                {{ getUserInitials(user.name) }}
            </div>

            <!-- Name + Role (expanded only) -->
            @if (!layoutService.isSidebarCollapsed()) {
            <div class="flex-1 min-w-0 overflow-hidden">
                <div class="font-bold text-white text-[13px] leading-tight truncate select-none">{{ user.name }}</div>
                <div class="text-slate-400 text-[11px] truncate select-none">{{ getRoleLabel(user.role) }}</div>
            </div>

            <!-- User Settings Icon button -->
            <button type="button" (click)="openUserSettings()" id="user-settings-btn"
                class="shrink-0 w-8 h-8 rounded-lg bg-[#1e293b]/80 border border-white/10 flex items-center justify-center hover:bg-white/10 transition-colors"
                matTooltip="User Settings" matTooltipPosition="right">
                <img src="assets/icons/user-settings.svg" alt="User Settings" class="w-[18px] h-[18px]" />
            </button>
            }
        </div>

    </div>
    }
</div>

<!-- User Settings Modal -->
<fk-modal [isOpen]="isUserSettingsOpen()" (close)="isUserSettingsOpen.set(false)" [closeOnOutsideClick]="true">
    <fk-user-settings-modal (closed)="isUserSettingsOpen.set(false)"></fk-user-settings-modal>
</fk-modal>

<!-- Logout Confirmation Modal -->
<fk-modal [isOpen]="isLogoutModalOpen()" (close)="isLogoutModalOpen.set(false)">
    <div class="w-full min-w-[380px] max-w-[420px] p-8 bg-white rounded-2xl text-center flex flex-col items-center">
        <!-- Logo -->
        <div class="mb-6 flex justify-center w-full select-none">
            <img src="assets/images/logo-dark.svg" alt="FreightKey" class="h-9 object-contain" />
        </div>

        <!-- Message -->
        <p class="text-slate-500 font-medium text-base mb-8 select-none">
            Are you sure you want to logout?
        </p>

        <!-- Action Buttons -->
        <div class="flex items-center justify-center gap-lg w-full">
            <fk-button label="No" variant="ghost" (click)="isLogoutModalOpen.set(false)"
                extraClass="text-slate-500 font-semibold hover:text-slate-700"></fk-button>
            <fk-button label="Yes" variant="primary" (click)="confirmLogout()"
                extraClass="bg-blue-600 hover:bg-blue-700 font-semibold px-6 !h-10 rounded-lg"></fk-button>
        </div>
    </div>
</fk-modal>